import {
  ON_KEY_PRESSED_DOWN_SET_KEY,
  ON_KEY_PRESSED_DOWN_SET_KEY_SUCCESS,
  ON_KEY_PRESSED_DOWN_SET_KEY_FAILURE,
} from "./actionType";

// Actions
export const onKeyPressedDownSetKey = (payload) => ({
  type: ON_KEY_PRESSED_DOWN_SET_KEY,
  payload,
});

export const onKeyPressedDownSetKeySuccess = (payload) => ({
  type: ON_KEY_PRESSED_DOWN_SET_KEY_SUCCESS,
  payload,
});

export const onKeyPressedDownSetKeyFailure = (payload) => ({
  type: ON_KEY_PRESSED_DOWN_SET_KEY_FAILURE,
  payload,
});
